module.exports = __webpack_public_path__ + "img/37.cec5fba6.jpg";